import { type RouteRecordRaw } from 'vue-router'

export const ImportRouter: RouteRecordRaw[] = [
  {
    path: '/import',
    component: async () => import('./Import.vue'),
  },
]
